"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _dentalProductApi = require("@/api/dentalProductApi");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ProductDetail',
  data: function data() {
    return {
      loading: false,
      productId: null
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['productDetail'])),
  created: function created() {
    // 从路由参数获取商品ID
    this.productId = this.$route.query.id;

    // 如果vuex中没有商品详情数据，则通过API获取
    if (!this.productDetail && this.productId) {
      this.fetchProductDetail();
    }
  },
  methods: {
    fetchProductDetail: function fetchProductDetail() {
      var _this = this;
      this.loading = true;
      (0, _dentalProductApi.getProductDetail)(this.productId).then(function (response) {
        if (response) {
          // 处理返回的数据
          var productDetail = response;

          // 确保图片列表是数组
          if (typeof productDetail.imageList === 'string') {
            productDetail.imageList = productDetail.imageList.split(',').filter(function (url) {
              return url && url.trim() !== '';
            });
          } else if (!Array.isArray(productDetail.imageList)) {
            productDetail.imageList = [];
          }

          // 确保标签列表是数组
          if (typeof productDetail.tagList === 'string') {
            productDetail.tagList = productDetail.tagList.split(',').filter(function (tag) {
              return tag && tag.trim() !== '';
            });
          } else if (!Array.isArray(productDetail.tagList)) {
            productDetail.tagList = [];
          }

          // 保存到vuex
          _this.$store.commit('dental/SET_PRODUCT_DETAIL', productDetail);
        } else {
          _this.$message.error('获取商品详情失败');
        }
      }).catch(function (error) {
        console.error('获取商品详情失败:', error);
        _this.$message.error('获取商品详情失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
};